import { isLiveOrderbookHeatmap } from '@/service/ws/stream-routing-contract'
import type {
  MessageSubject,
  OrderbookHeatmap,
  OrderbookHeatmapColumn,
} from '@/types/generated/public_api'

export type GetCachedHeatmapColumn = (
  exchange: number,
  symbol: string
) => OrderbookHeatmapColumn | undefined

/** Snapshots are valid only while their channel stays subscribed on this socket. */
export function createHeatmapChannelCache() {
  const columns = new Map<string, OrderbookHeatmapColumn>()
  const key = (exchange: number, symbol: string) => `${exchange}:${symbol}`
  return {
    record(heatmap: OrderbookHeatmap | undefined) {
      if (!heatmap || !isLiveOrderbookHeatmap(heatmap)) return
      const column = heatmap.columns.at(-1)
      if (column) columns.set(key(heatmap.exchange, heatmap.symbol), column)
    },
    get(exchange: number, symbol: string) {
      return columns.get(key(exchange, symbol))
    },
    forget(channel: Partial<MessageSubject>) {
      const payload = channel.orderbookHeatmapStream
      if (payload) columns.delete(key(payload.exchange, payload.symbol))
    },
    clear() {
      columns.clear()
    },
  }
}
